module.exports = __webpack_public_path__ + "img/04.57067e2e.jpg";